<template>
  <div>
    {{ toDo.summary
    }}<i class="fas fa-edit ml-2 link" @click="handleEditClick"></i>
  </div>
</template>

<script>
import { EventBus } from "@/lib/event_bus.js";

export default {
  props: {
    toDo: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    handleEditClick() {
      EventBus.$emit("edit-to-do", this.toDo.id);
    }
  }
};
</script>

<style lang="scss" scoped></style>
